import { render, staticRenderFns } from "./PopoverMenu.vue?vue&type=template&id=16866d72&scoped=true&"
import script from "./PopoverMenu.vue?vue&type=script&lang=js&"
export * from "./PopoverMenu.vue?vue&type=script&lang=js&"
import style0 from "./PopoverMenu.vue?vue&type=style&index=0&id=16866d72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16866d72",
  null
  
)

export default component.exports